import React, { useCallback } from "react";
import List from "devextreme-react/list";
import PropTypes from "prop-types";
import {
  ResourceActiveSVG,
  ResouceVersionDeprecateSVG,
} from "../../Assets/SVGs/ResourceSVGs";
import {
  resourceVersionPropTypes,
  selectedResourcePropTypes,
} from "../../Constants/propTypes";
import "./ResourceVersionList.scss";

const ResourceVersionList = ({
  setSelectedResourceVersion,
  selectedResource,
  selectedResourceVersion,
}) => {
  const handleItemClick = useCallback(
    (e) => {
      setSelectedResourceVersion(e.itemData);
    },
    [setSelectedResourceVersion]
  );

  const ItemTemplate = useCallback((resourceVersion) => {
    const itemClass = resourceVersion.active ? "active-item" : "inactive-item";
    return (
      <div className={`container ${itemClass}`}>
        <div className="version-details">
          <span className="version-name ellipsis" title={resourceVersion.name}>
            {resourceVersion.name.length > 22
              ? `${resourceVersion.name.substring(0, 19)}...`
              : resourceVersion.name}
          </span>
          <div className="version-number">Version {resourceVersion.versionNumber}</div>
        </div>
        <span className="version-status">
          {resourceVersion.active ? (
            <span>{ResourceActiveSVG}</span>
          ) : (
            <span>{ResouceVersionDeprecateSVG}</span>
          )}
        </span>
      </div>
    );
  }, []);

  return (
    <div style={{ height: "100%" }}>
      <div className="resources-list">
        <div className="list-container">
          <List
            dataSource={selectedResource.resourceVersions}
            itemRender={ItemTemplate}
            searchExpr="versionNumber"
            searchEnabled={true}
            selectionMode="single"
            onItemClick={handleItemClick}
            selectedItems={[selectedResourceVersion]}
          />
        </div>
      </div>
    </div>
  );
};

ResourceVersionList.propTypes = {
  setSelectedResourceVersion: PropTypes.func.isRequired,
  selectedResource: selectedResourcePropTypes.isRequired,
  selectedResourceVersion: resourceVersionPropTypes,
};
export default ResourceVersionList;
